import React from "react"
const CommonAchievement = ({ data }) => {
  return (
    <div className="md:px-20 bg-white-250 h-full md:pe-20 px-6 flex flex-col  ">
      <div className="items-center w-max  basis-full flex gap-32 md:gap-20 xl:gap-32 flex-row">
        <div className="flex w-[350px]  md:w-[590px] xl:w-[650px] flex-col gap-4 md:gap-16 ">
          <div className="flex flex-col items-start gap-4 w-full">
            <h2
              className={`text-gray-100 text-3xl md:text-5xl lg:text-8xl tracking-[-.96px] md:tracking-tight-2% lg:tracking-tight-7%`}
            >
              What we achieved
            </h2>
            <p
              className={`text-[1.08rem] md:text-[1.125rem] mt-0 md:mt-6 xl:mt-8 text-start text-black-300 `}
            >
              {data.description}
            </p>
          </div>
          <div className="flex max-w-[80%] items-center gap-4 flex-wrap">
            {data.tags.map(item => (
              <div className="p-3 text-black-600 rounded-[50px] bg-primary-100">
                <span>✓</span> {item}
              </div>
            ))}
          </div>
        </div>

        {data.imageSection}
      </div>
    </div>
  )
}

export default CommonAchievement
